import React from 'react';
import { Menu } from '@material-ui/icons';
import { TextField } from '@material-ui/core';

import { useTranslate } from 'shared/components/translate';

const getInputLabel = (props) => {
  if (!props.isMulti) {
    return props.value ? props.getOptionLabel(props.value) : '';
  }

  if (Array.isArray(props.value)) {
    return props.value.map(opt => props.getOptionLabel(opt)).join(', ');
  }

  return '';
}

const DialogInput = ({ options, setOpen, disabled, ...props }) => {
  const translate = useTranslate();

  return (<TextField
    disabled={disabled}
    label=" "
    fullWidth
    InputProps={{ readOnly: true, endAdornment: <Menu disabled={disabled} color="primary" />, style: { cursor: "pointer" } }}
    InputLabelProps={{ shrink: true }}
    placeholder={translate("common.select")}
    onClick={() => {
      if (!disabled) {
        setOpen(true)
      }
    }}
    value={getInputLabel(props)}
  />);
}

export default DialogInput